import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

import { AppConfig, APP_CONFIG_TOKEN } from "libs/config/app.lib.config";
import { CA_WEBVIEWER_APP_URL } from "libs/web-viewer/src/lib/models/web-viewer-app.model";

@Injectable({
	providedIn: "root"
})
export class TreatmentBaseService {
	private http = inject(HttpClient);
	private sanitizer = inject(DomSanitizer);
	private config = inject<AppConfig>(APP_CONFIG_TOKEN);

	getCaWebViewerSource(): SafeResourceUrl {
		return this.sanitizer.bypassSecurityTrustResourceUrl(CA_WEBVIEWER_APP_URL);
	}

	getTreatmentViewer(treatmentId: string, mediumId: string, caseId?: string) {
		mediumId = mediumId || "0";
		return this.http.get(`${this.config.apiUrl}/treatments/${treatmentId}/${mediumId}/viewer`, {
			params: caseId != null ? { caseId } : {},
			withCredentials: true
		});
	}
}
